import React from 'react';
import { Modal, Button, Table, Badge, Row, Col, Card } from 'react-bootstrap';

const OCRDetailsModal = ({ show, onHide, fileData }) => {
  const formatReadability = (ocrConfidence) => {
    if (ocrConfidence === null || ocrConfidence === undefined) {
      return 'N/A';
    }
    return `${Math.round(ocrConfidence * 10) / 10}%`;
  };

  const getConfidenceVariant = (confidence) => {
    if (confidence >= 80) return 'success';
    if (confidence >= 60) return 'warning';
    return 'danger';
  };

  const getExtractionMethodVariant = (method) => {
    switch (method) {
      case 'native': return 'primary';
      case 'ocr': return 'secondary';
      case 'failed': return 'danger';
      default: return 'light';
    }
  };

  const renderOverallStats = () => {
    if (!fileData?.readability) return null;

    return (
      <Row className="mb-4">
        {/* <Col md={3}>
          <Card className="text-center h-100">
            <Card.Body>
              <h4 className="text-primary">{formatReadability(fileData.readability.score)}</h4>
              <small className="text-muted">Overall Score</small>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="text-center h-100">
            <Card.Body>
              <h4 className="text-success">{fileData.readability.page_coverage}%</h4>
              <small className="text-muted">Page Coverage</small>
            </Card.Body>
          </Card>
        </Col> */}
        <Col md={6}>
          <Card className="text-center h-100">
            <Card.Body>
              <h4 className="text-info">{fileData.readability.total_pages}</h4>
              <small className="text-muted">Total Pages</small>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="text-center h-100">
            <Card.Body>
              <h4 className="text-warning">{formatReadability(fileData.readability.ocr_confidence)}</h4>
              <small className="text-muted">Avg OCR Confidence</small>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    );
  };

  const renderPageDetails = () => {
    if (!fileData?.readability?.page_details || fileData.readability.page_details.length === 0) {
      return (
        <div className="text-center py-4">
          <p className="text-muted">No detailed page information available</p>
        </div>
      );
    }

    return (
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Page</th>
            <th>OCR Confidence</th>
            <th>Characters</th>
          {/*   <th>Words</th> */}
           </tr>
        </thead>
        <tbody>
          {fileData.readability.page_details.map((page, index) => (
            <tr key={index}>
              <td>{page.page_num}</td>
              <td>
                {page.ocr_confidence ? (
                  <Badge variant={getConfidenceVariant(page.ocr_confidence)}>
                    {formatReadability(page.ocr_confidence)}
                  </Badge>
                ) : (
                  <span className="text-muted">N/A</span>
                )}
              </td>
              <td>{page.char_count || 0}</td>
              {/* <td>
                {page.word_count ? (
                  <div>
                    <div>Total: {page.word_count}</div>
                    {page.low_confidence_words > 0 && (
                      <small className="text-danger">
                        Low conf: {page.low_confidence_words}
                      </small>
                    )}
                  </div>
                ) : (
                  <span className="text-muted">N/A</span>
                )}
              </td> */}
            </tr>
          ))}
        </tbody>
      </Table>
    );
  };

  return (
    <Modal show={show} onHide={onHide} scrollable>
      <Modal.Header closeButton>
        <Modal.Title>
        Readability Details: {fileData?.name || 'Unknown File'}
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        {/* Overall Statistics */}
        {renderOverallStats()}
        
        {/* Page Details Table */}
        <h5 className="mb-3">Page-by-Page Details</h5>
        {renderPageDetails()}
      </Modal.Body>
      
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OCRDetailsModal;